<template>
    <div class="modal-body pt-0 pb-0 pl-0 pr-0">
        <div class="card lists mb-0">
            <div class="card-header">
                <div class="row align-items-center pt-3">
                    <div class="col">
                        <div class="row align-items-center">
                            <div class="col-12 col-md-4 col-lg-3 mb-3 mb-3 mb-md-0 pr-3 pr-md-0">
                                <div class="input-group input-group-merge">
                                    <input v-model="search" type="search" class="form-control form-control-prepended" placeholder="Tìm rạp tại">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">
                                            <span class="fe fe-search"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-5 col-lg-4">
                                <select class="form-control btn-select-region search" data-toggle="select" v-model="region">
                                    <template v-for="region in regions">
                                        <option :value="region.id" :key="region.id">{{ region.name }}</option>
                                    </template>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto"></div>
                </div> <!-- / .row -->
            </div>

            <div class="pt-3" v-if="cinemas.length > 0">
                <div class="border-bottom" v-for="cinema in filteredCinemas">
                    <div class="row align-items-center pl-4 pr-4 pb-3 pt-3">
                        <div class="col-auto">
                            <a :href="$root.url('orn_web_cinema_view', { slug : cinema.slug })"
                               class="avatar avatar-sm">
                                <img :src="cinema.cineplex && cinema.cineplex.logo ? cinema.cineplex.logo.sizes.square : $root.asset('bundles/ornweb/img/no-thumbnail.png')"
                                     :data-src="cinema.cineplex && cinema.cineplex.logo ? cinema.cineplex.logo.sizes.square : $root.asset('bundles/ornweb/img/no-thumbnail.png')"
                                     :alt="cinema.name" class="lazyload avatar-img rounded-circle">
                            </a>
                        </div>
                        <div class="col ml-n2">
                            <h4 class="card-title mb-1">
                                <a :href="$root.url('orn_web_cinema_view', { slug : cinema.slug })" class="name">{{
                                    cinema.name }}</a>
                                <span class="badge badge-soft-primary" v-if="cinema.adapter === 'ticketing' || cinema.adapter === 'affiliate'">bán vé</span>
                                <span class="badge badge-soft-primary" v-if="cinema.adapter === 'voucher'">bán voucher</span>
                            </h4>
                            <p class="card-text small text-muted address mb-0">
                                {{ cinema.address }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'Cinemas',
        data() {
            return {
                search: '',
                region: this.$root.getRegion(),
                cinemas: [],
                regions: [],
                errors: []
            }
        },
        created() {
            this.getRegion()
            this.getCinemas()
        },
        methods: {
            getRegion() {
                let baseUri = process.env.MOVEEK_API_ENDPOINT;
                axios.get(baseUri + '/v1/regions?order[priority]=ASC')
                .then(res => {
                    this.regions = res.data
                })
                .catch(e => {
                    this.errors.push(e)
                });
            },
            getCinemas(page = 1) {
                let baseUri = process.env.MOVEEK_API_ENDPOINT;
                axios.get(baseUri + `/v1/cinemas?region.id=${this.region}&status=publish&closed=false&opening_soon=false&page_size=100&order[cineplex.name]=ASC&order[name]=ASC&page=${page}`)
                    .then(response => {
                        this.cinemas = [...this.cinemas, ...response.data]
                        if (response.data.length === 100) {
                            page = page + 1;
                            this.getCinemas(page)
                        } else {
                            this.cinemas = this.cinemas.map(function (cinema) {
                                if (cinema.cineplex == null) {
                                    cinema.cineplex = {
                                        id: 0,
                                        name: 'Khác',
                                        logo: {
                                            sizes: {
                                                'tiny': $root.asset('bundles/ornweb/img/no-thumbnail.png'),
                                                'square': $root.asset('bundles/ornweb/img/no-thumbnail.png')
                                            }
                                        },
                                        sponsored: false
                                    }
                                }

                                return cinema;
                            })
                            this.cinemas.sort((x, y) => y.sponsored - x.sponsored || y.cineplex.sponsored - x.cineplex.sponsored);
                        }
                    })
                    .catch(e => {
                        this.errors.push(e)
                    });
            }
        },
        computed: {
            filteredCinemas() {
                return this.cinemas.filter(cinema => {
                    return cinema.name.toLowerCase().includes(this.search.toLowerCase())
                })
            }
        },
        watch: {
            region() {
                this.cinemas = []
                this.getCinemas()
            }
        }
    }
</script>

<style scoped>
</style>
